import { useMemo } from 'react';

import Tooltip from '~components/common/Tooltip';
import ExclamationMark from '~components/Icon/ExclamationMark';
import Text from '~components/Text';
import { getRankRate, getRankRateSection } from '~hooks/query/company/useCompanyEmployee';
import theme from '~lib/styles/Theme';
import { Employee } from '~types/company';

import { EmployeeInfoCard, Row } from '../style';

function EmployeeRate({
  title,
  tooltipText,
  employee,
  type,
}: {
  title: string;
  tooltipText?: string;
  employee: Employee;
  type: 'hired' | 'left' | 'total';
}) {
  const employeeRateText = useMemo(() => {
    const rate = getRankRate(type, employee);
    const rateText = getRankRateSection(rate);

    return rateText;
  }, [type, employee]);

  return (
    <EmployeeInfoCard>
      <Row>
        <Text typography='midium120_B3'>{title}</Text>
        {tooltipText && (
          <Tooltip width={255} tooltipText={tooltipText} position='center'>
            <ExclamationMark width={15} color={theme.colors.gray700} />
          </Tooltip>
        )}
      </Row>
      <hr />
      <Row>
        <Text typography='bold120_T1'>{employeeRateText.main}</Text>
        <Text typography='bold120_B2'>{employeeRateText.mainBrace}</Text>
      </Row>
      <Row>
        <Text typography='midium150_C1'>
          <span className='grayColor'>
            {employee.rateType === 'INDUSTRY' ? '동종업계' : '전체'}
          </span>
          <strong className='emphasize'> {employeeRateText.description} </strong>
        </Text>
        <Text typography='midium150_C1'>{employeeRateText.descriptionBrace}</Text>
      </Row>
    </EmployeeInfoCard>
  );
}

export default EmployeeRate;
